class DeckComparison {
    constructor() {
        if (0 < jQuery(`.btn-compare-cc-decks`).length) this.prepareCheckBox()
        if (0 < jQuery(`.table-comparison`).length) this.buildComparisonTable()
    }

    prepareCheckBox() {
        var hero_name = jQuery('.page-banner__title').html()
        jQuery(`table.fabdojo-table :checkbox`).click(function () {
            var self = jQuery(this)
                , headerCb = jQuery(`table.fabdojo-table th :checkbox`)
                , bodyCb = jQuery(`table.fabdojo-table td :checkbox`)
                , isChecked = self.is(`:checked`)

            if (self.is(headerCb)) bodyCb.prop(`checked`, isChecked)
        })
        jQuery(`.btn-compare-cc-decks`).click(function (event) {
            event.preventDefault()
            var selected_decks = []
            jQuery(`[data-deck-id]:checked`).each(function () {
                selected_decks.push(this.getAttribute(`data-deck-id`))
            })
            if (0 < selected_decks.length) window.location.href = `../../deck-comparison?hero_name=${hero_name}&decks=` + selected_decks.join(`,`)
        })
        jQuery(`.btn-compare-blitz-decks`).click(function (event) {
            event.preventDefault()
            var selected_decks = []
            jQuery(`[data-deck-id]:checked`).each(function () {
                if ('Blitz' === jQuery(this).parent().parent().find(`td`).eq(4).html())
                    selected_decks.push(this.getAttribute(`data-deck-id`))
            })
            if (0 < selected_decks.length) window.location.href = `../../deck-comparison?hero_name=${hero_name}&decks=` + selected_decks.join(`,`)
        })
    }

    buildComparisonTable() {
        var urlParams = new URLSearchParams(window.location.search)
        var ids = urlParams.get(`decks`)
        var compared_deck_form = jQuery(`#compared_decks_form`)
        var compared_deck_input = compared_deck_form.find(`[name="decks"]`)
        document.title = urlParams.get('hero_name')
        jQuery.get(window.location.href.split(`/deck-comparison`)[0] + `/wp-json/deck-comparison/v1/data`, { ids }, function (data) {
            var { decks, cards, infos } = data
            var td_count = decks.length + 3
                , th_count = 10
                , comparison_table = jQuery(`.table-comparison`)

            comparison_table.append(`<thead></thead>`)
            for (var thead = 0; thead <= th_count; thead++) comparison_table.find(`thead`).append(`<tr></tr>`)
            for (var td = 0; td < td_count; td++) comparison_table.find(`thead tr`).append(`<th></th>`)

            var deck_labels = { 4: `Placing`, 5: `Equipment`, 6: `No Pitch`, 7: `Red`, 8: `Yellow`, 9: `Blue` }
            for (var deck_label_row in deck_labels) comparison_table
                .find(`thead`)
                .find(`tr`).eq(deck_label_row)
                .find(`th`).eq(0)
                .attr('align', 'left')
                .html(deck_labels[deck_label_row])

            var deck_td = 3
            for (var deck of decks) {
                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(0)
                    .find(`th`).eq(deck_td)
                    .attr(`data-deck-id`, deck.ID)
                    .html(`<div class="rotate"><a href="${deck.guid}">${deck.player_name}</a></div>`)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(1)
                    .find(`th`).eq(deck_td)
                    .html(deck.placing)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(2)
                    .find(`th`).eq(deck_td)
                    .html(`
                        <a href="javascript:;" data-deck="${deck.ID}" class="player_button">
                            <img src="${window.location.href.split(`/deck-comparison`)[0] + `/wp-content/themes/fabdojo/images/x.jpeg`}">
                        </a>
                    `)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(3)
                    .find(`th`).eq(deck_td)
                    .html(deck.event_date)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(4)
                    .find(`th`).eq(deck_td)
                    .html(deck.placing)

                var deck_infos = infos.filter(info => {
                    return info.player_id == deck.ID
                })

                var deck_cards = []
                for (var card of cards) {
                    for (var info of deck_infos) {
                        if (card.identifier == info.identifier) {
                            card.info_qty = parseInt(info.qty)
                            deck_cards.push(card)
                        }
                    }
                }

                var equipment = 0
                var no_pitch = 0
                var red = 0
                var yellow = 0
                var blue = 0
                for (var deck_card of deck_cards) {
                    if ("1" === deck_card.is_equipment) equipment += deck_card.info_qty
                    if ("1" === deck_card.no_pitch) no_pitch += deck_card.info_qty
                    if ("1" === deck_card.red) red += deck_card.info_qty
                    if ("1" === deck_card.yellow) yellow += deck_card.info_qty
                    if ("1" === deck_card.blue) blue += deck_card.info_qty
                }

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(5)
                    .find(`th`).eq(deck_td)
                    .html(0 != equipment ? equipment : `-`)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(6)
                    .find(`th`).eq(deck_td)
                    .html(0 != no_pitch ? no_pitch : `-`)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(7)
                    .find(`th`).eq(deck_td)
                    .html(0 != red ? red : `-`)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(8)
                    .find(`th`).eq(deck_td)
                    .html(0 != yellow ? yellow : `-`)

                comparison_table
                    .find(`thead`)
                    .find(`tr`).eq(9)
                    .find(`th`).eq(deck_td)
                    .html(0 != blue ? blue : `-`)

                deck_td++
            }
            jQuery(`[data-deck]`).click(function () {
                var current_decks = compared_deck_input.val()
                var selected_deck = jQuery(this).attr(`data-deck`)
                current_decks = current_decks.split(`,`)
                current_decks = current_decks.filter(curdeck => curdeck !== selected_deck)
                current_decks = current_decks.join(`,`)
                compared_deck_input.val(current_decks)
                compared_deck_form.submit()
            })

            comparison_table.append(`<tbody></tbody>`)
            for (var tbody = 0; tbody <= cards.length - 1; tbody++) comparison_table.find(`tbody`).append(`<tr class="row"></tr>`)
            for (var td = 0; td < td_count; td++) comparison_table.find(`tbody tr`).append(`<th>-</th>`)

            var card_tr = 0
            for (var card of cards) {
                var tbody_tr = comparison_table
                    .find(`tbody`)
                    .find(`tr`).eq(card_tr)

                tbody_tr.attr(`data-card-identifier`, card.identifier)
                tbody_tr.attr(`data-th-color`, card.th_color)

                tbody_tr.find(`th`).eq(0)
                    .html(`<div class="label">${card.name}</div>`)

                tbody_tr.find(`th`).eq(1)
                    .html(`
                        <div class="container">
                            <div class="split">
                                <a class="card_button" data-only data-row-index="${card_tr}">
                                    <img src="${window.location.href.split(`/deck-comparison`)[0] + `/wp-content/themes/fabdojo/images/check.jpeg`}" style="max-width:none">
                                </a>
                            </div>
                            <div class="split">
                                <a class="card_button" data-except data-row-index="${card_tr}">
                                    <img src="${window.location.href.split(`/deck-comparison`)[0] + `/wp-content/themes/fabdojo/images/x.jpeg`}" style="max-width:none">
                                </a>
                            </div>
                        </div>
                    `)

                card_tr++
            }

            jQuery(`[data-only]`).click(function () {
                var row_index = jQuery(this).attr(`data-row-index`)
                var included_decks = []
                comparison_table.find(`tbody tr`).eq(row_index).find(`th`).each(function () {
                    var th = jQuery(this)
                    var deck = comparison_table.find(`thead tr`).find(`th`).eq(th.index()).attr(`data-deck-id`)
                    if (deck && th.html() !== `-`) included_decks.push(deck)
                })
                compared_deck_input.val(included_decks)
                compared_deck_form.submit()
            })
            jQuery(`[data-except]`).click(function () {
                var row_index = jQuery(this).attr(`data-row-index`)
                var included_decks = []
                comparison_table.find(`tbody tr`).eq(row_index).find(`th`).each(function () {
                    var th = jQuery(this)
                    var deck = comparison_table.find(`thead tr`).find(`th`).eq(th.index()).attr(`data-deck-id`)
                    if (deck && th.html() === `-`) included_decks.push(deck)
                })
                compared_deck_input.val(included_decks)
                compared_deck_form.submit()
            })

            for (var info of infos) {
                var tr = comparison_table.find(`tr[data-card-identifier="${info.identifier}"]`).index()
                var th = comparison_table.find(`th[data-deck-id="${info.player_id}"]`).index()
                comparison_table
                    .find(`tbody`)
                    .find(`tr`).eq(tr)
                    .find(`th`).eq(th)
                    .html(info.qty)
            }

            comparison_table.find(`tbody tr`).each(function () {
                var tr = jQuery(this)
                var th_avg = 2
                var th_hero = 3
                var th_length = tr.find(`th`).length
                var hero_length = th_length - th_hero

                var total = 0
                for (var th = th_hero; th < th_length; th++) {
                    var col = tr.find(`th`).eq(th)
                    var number = col.html()
                    col.css('background-color', tr.attr(`data-th-color`))
                    total += parseInt(`-` !== number ? number : 0)
                }

                tr.find(`th`).eq(th_avg).html((total / hero_length).toFixed(1)).css('background-color', tr.attr(`data-th-color`))
            })

        })
    }

}

export default DeckComparison